import { CORRELATIONS_INTRO_HTML, ACKNOWLEDGEMENTS_HTML } from './htmlMessageSlides';

export interface SectionDef {
  slug: string;
  label: string;
  startId?: string;
  theme?: string;
  introHtml?: string;
  ids?: string[]; // optional explicit ordered list of question IDs in this section
  htmlOnly?: boolean; // if true, only render introHtml with no data slides
}

export const SECTIONS: SectionDef[] = [
  { slug: 'demographics-high-school', label: 'Demographics & High School', startId: 'A5', theme: 'emerald', ids: ["A5-13","A27-29", "A32", "A30-35"] },
  { slug: 'school-life', label: 'School Life', startId: 'A1', theme: 'blue', ids: ["A1-4", "A14-25", 'A26-used', 'A26-kinds', "A38-64", "A37", "A65-75"] },
  { slug: 'co-op', label: 'Co-op', startId: 'B1', theme: 'rose', ids: ['B1-50', 'B52-59', 'B51-used', 'B51-kinds', 'B60-65', 'B-coop-location-flow'] },
  { slug: 'academics', label: 'Academics', startId: 'B66', theme: 'amber', ids: ['B66-102', 'B128'] },
  { slug: 'future-plans', label: 'Future Plans', startId: 'B103', theme: 'fuchsia', ids: ['B103-117', 'A36', 'B129', 'B131', 'B133', 'B134', 'B135', 'B136', 'B137', 'B138', 'B139', 'B140'] },
  { slug: 'reflections', label: 'Reflections & Advice', startId: 'B118', theme: 'rose' },
  { slug: 'correlations', label: 'Correlations', startId: 'C1', theme: 'cyan', introHtml: CORRELATIONS_INTRO_HTML },
  { slug: 'acknowledgements', label: 'Acknowledgements', theme: 'indigo', introHtml: ACKNOWLEDGEMENTS_HTML, htmlOnly: true },
];
